export default __webpack_public_path__ + "static/8-3348e0eac6629a6118f6d6095d011179.jpg";